<template>
    <section class="hero-section">
      <div class="overlay"></div>
  
      <div class="hero-content centered">
        <div class="text-content">
          <p class="subtitle">Welcome To StreamBox</p>
          <h1 class="title">Operators</h1>
          <p class="description">
            Become a operator and get access to a dedicated web panel for customizing your app experience — fully personalized for your users to enhance engagement and satisfaction.
            For small/medium cable operators.
          </p>
  
    <ul class="features-list">
  <li>Support for Flussonic and Xtream Codes API</li>
  <li>Support for M3U8 playlists</li>
  <li>Customizable home screen with operator-selected content</li>
  <li>Web-based content management panel</li>
  <li>Live and time-shifted TV playback</li>
  <li>Real-time rewind functionality*</li>
  <li>Live TV channel browsing</li>
  <li>Movie and series catalog with search</li>
  <li>Advanced grouping of movies and series</li>
  <li>Detailed descriptions with seasons and episodes</li>
  <li>Favorites for channels, movies, and series</li>
  <li>Operator-curated recommendations</li>
  <li>Modern and intuitive EPG</li>
  <li>Radio channel support</li>
  <li>Support for 40+ UI languages</li>
  <li>Customizable favorite channel list</li>
  <li>Promo banners and news on home screen</li>
  <li>Unlimited playlist support</li>
  <li>Device activation via unique Device ID</li>
</ul>
<p style="font-size: 12px; color: #aaa; text-align: left; max-width:800px; margin:auto; margin-top:10px;">*Available only with Flussonic server</p>

  
          <div class="platform-section">
            <p class="platform-title">Available on:</p>
          
            <div class="platform-icons">
              <!-- Ti dodaj slike gde treba -->
              <a href="https://play.google.com/store/apps/details?id=com.streamboxtv" ><img src="@/assets/googlePlay.png" alt="Google Play" />  </a>
            
              <a href="https://www.amazon.com/gp/product/B0F8XSW84W" ><img src="@/assets/amazonFire.png" alt="Amazon" />  </a>
                      <img src="@/assets/samsungPoweredByTizen.png" alt="Amazon Fire TV" class="platform-logo" />
              <a href="https://streamboxtv.live/app.apk" ><img src="@/assets/customAPKIcon.png" alt="Google Play" />  </a>
              <!-- Dodaj još ako treba -->
            </div>
          </div>
          <div class="platform-section" style="margin-top:100px;">
            <br>
            <p class="platform-title">Important</p>
            <p class="description">
                This app includes no content by default. All media shown in previews is for promotional use only. Users/Resellers must supply their own playlists.
          </p>
          </div>
    
        </div>
      </div>
    </section>
    <div id="line"></div>
  </template>
  
  <script>
  export default {
    name: "LandingHero",
  };
  </script>
  
  <style scoped>
  .hero-section {
    color: white;
    padding: 80px 20px;
    background: url("@/assets/back2.jpg") no-repeat center center;
    background-size: cover;
    position: relative;
  }
  
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
  
  .hero-content.centered {
    position: relative;
    z-index: 2;
    max-width: 900px;
    margin: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .text-content {
    max-width: 700px;
    margin: 0 auto;
  }
  
  .subtitle {
    color: #42a5f5;
    font-size: 1rem;
    margin-bottom: 10px;
  }
  
  .title {
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 20px;
    filter: drop-shadow(0 0 30px #0f3b99);
  }
  
  .description {
    font-size: 1.1rem;
    color: #ccc;
    margin-bottom: 30px;
    filter: drop-shadow(0 0 30px #0f3b99);
  }
  
  .features-list {
   
    padding: 20px;
    margin: 0 0 30px;
    text-align: left;
    color: #fff;
    font-size: 1rem;
    line-height: 1.8;
    max-width: 500px;
    margin-inline: auto;
  }
  
  .platform-section {
    margin: 20px 0;
  }
  
  .platform-title {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 1rem;
  }
  
  .platform-icons {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
  
  .platform-icons img {
    height: 40px;
    filter: drop-shadow(0 0 5px #0f3b99);
  }
  
  .platform-buttons {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  
  .platform {
    padding: 12px 24px;
    background: #2a84ff;
    border: none;
    color: white;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .platform:hover {
    background-color: white;
    color: black;
  }
  
  #line {
    width: 100%;
    height: 2px;
    background: linear-gradient(
      90deg,
      rgba(2, 0, 36, 1) 0%,
      rgba(0, 99, 255, 1) 9%,
      rgba(23, 46, 147, 1) 27%,
      rgba(222, 0, 127, 1) 46%,
      rgba(0, 72, 202, 1) 65%,
      rgba(171, 0, 78, 1) 82%,
      rgba(9, 9, 121, 1) 100%
    );
    background-size: 200% 100%;
    animation: move-gradient 10s linear infinite alternate;
    box-shadow: 0px 5px 20px rgb(0, 0, 0);
    margin-top: 0;
  }
  
  @keyframes move-gradient {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 100% 0%;
    }
  }
   


  #line {
  width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(0, 99, 255, 1) 9%,
    rgba(23, 46, 147, 1) 27%,
    rgba(222, 0, 127, 1) 46%,
    rgba(0, 72, 202, 1) 65%,
    rgba(171, 0, 78, 1) 82%,
    rgba(9, 9, 121, 1) 100%
  );
  background-size: 200% 100%;
  animation: move-gradient 10s linear infinite alternate;
  box-shadow: 0px 5px 20px rgb(0, 0, 0);
  margin-top: 0px; /* da ne seče nav */
}

@keyframes move-gradient {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 100% 0%;
  }
}
.platform-section {
    margin: 20px 0;
  }
  
  .platform-title {
    font-weight: bold;
    margin-bottom: 10px;
    font-size: 1rem;
  }
  .platform-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  max-width: 100%;

}

.platform-icons img {
  height: 40px;
  filter: drop-shadow(0 0 5px #0f3b99);
  flex-shrink: 0;
}

  .activate-button{
    padding: 12px 24px;
    font-size:1.1em;
    border: none;
    color: white;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;
    text-shadow:1px 1px 20px rgba(0, 0, 0, 0.699);
    background: linear-gradient(135deg, #ffc400, #FF8C00);
  }
  

  </style>
  